// @flow
import * as React from 'react'

import './LayoutItem.module.scss'

type Props = {
  grow?: boolean,
  children: React.Node,
}

export default function LayoutItem(props: Props) {
  const modifier = props.grow ? 'grow' : ''

  return <div styleName={`root ${modifier}`}>{props.children}</div>
}
